import { createContext, FC, ReactNode, useContext } from "react";

export interface AssistantWidgetContextValue {
  closePanel: () => void;
}

const AssistantWidgetContext = createContext<AssistantWidgetContextValue | null>(null);

interface AssistantWidgetProviderProps {
  value: AssistantWidgetContextValue;
  children: ReactNode;
}

export const AssistantWidgetProvider: FC<AssistantWidgetProviderProps> = ({ value, children }) => (
  <AssistantWidgetContext.Provider value={value}>{children}</AssistantWidgetContext.Provider>
);

export const useAssistantWidgetContext = () => useContext(AssistantWidgetContext);
